// TODO:之後整理 view_dr開頭的 api
import defaultApi from '@/utils/request';

export default {
  // 學制
  LoadDgr(params) {
    return defaultApi({
      method: 'get',
      url: 'view_dr_profile_std/LoadDgr',
      params,
    });
  },
  // 院別
  LoadDpt(params) {
    return defaultApi({
      method: 'get',
      url: 'view_dr_profile_std/LoadDpt',
      params,
    });
  },
  // 系所
  LoadUnit(params) {
    return defaultApi({
      method: 'get',
      url: 'view_dr_profile_std/LoadUnit',
      params,
    });
  },
};
